import React, { Component } from 'react'
import BatchUpdate from './modals/BatchUpdate'
import ExportModal from './modals/ExportModal'
import ImportModal from './modals/ImportModal'
import PrintModal from './modals/PrintModal'


export default class OpenModalsTest extends Component {
    state = {

    }






    render() {
        return (
            <div ref={el => this.container = el} className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar' style={{ background: "#f6f6f6" }}>
                <div className='flexcc flex-column h-100 w-100'>
                    <button style={{ backgroundColor: "#fff" }} className='flexc px-5 py-4 br-20 shadow-1 my-2' onClick={() => this.PrintModal.modal.showModal()}>
                        <p>Open Print Modal</p>
                    </button>
                    <button style={{ backgroundColor: "#fff" }} className='flexc px-5 py-4 br-20 shadow-1 my-2' onClick={() => this.ImportModal.modal.showModal()}>
                        <p>Open import Modal</p>
                    </button>
                    <button style={{ backgroundColor: "#fff" }} className='flexc px-5 py-4 br-20 shadow-1 my-2' onClick={() => this.ExportModal.modal.showModal()}>
                        <p>Open Export Modal</p>
                    </button>
                    {/* <button style={{ backgroundColor: "#fff" }} className='flexc px-5 py-4 br-20 shadow-1 my-2' onClick={() => this.BatchUpdate.modal.showModal()}>
                        <p>Open Batch Update Modal</p>
                    </button> */}
                </div>
                <PrintModal width={this.props.width} closeModal={() => this.PrintModal.modal.hideModal()} ref={el => this.PrintModal = el} data={this.state?.course} />
                <ImportModal width={this.props.width} closeModal={() => this.ImportModal.modal.hideModal()} ref={el => this.ImportModal = el} data={this.state?.course} />
                <ExportModal width={this.props.width} closeModal={() => this.ExportModal.modal.hideModal()} ref={el => this.ExportModal = el} data={this.state?.course} />
                {/* <BatchUpdate width={this.props.width} closeModal={() => this.BatchUpdate.modal.hideModal()} ref={el => this.BatchUpdate = el} data={this.state?.course} /> */}
            </div>
        )
    }
}
